import { IListItem } from "../list-item"
import { IState } from "../state"

export interface IDonorProfileAddress {
    donorId: number
    centerId: number
    firstName: string
    lastName: string
    fullName: string
    country: number
    addressLine1: string
    addressLine2: string
    city: string
    state: string
    postalCode: string
    birthDate: string
    phone: string
    phone2: string
    email: string
    isAdp: boolean
    source: any
}

export interface IDonorProfileAddressPost {
    fullName: string
    country: number
    addressLine1: string
    addressLine2: string
    city: string
    state: string
    postalCode: string
    phone: string
    phone2: string
    email: string
    source: any
}

export interface IDonorProfileAddressLookupData {
    countryList: IListItem[]
    stateList: IState[]
}